module.exports = __webpack_public_path__ + "NLSenaPage-image-on-topleft-89f1656c1d0c30c1fd03.png";